import React, { useEffect, useState } from 'react';
import { useSearchParams, Link } from 'react-router-dom';
import { HiCheckCircle, HiXCircle } from 'react-icons/hi';
const SuccessPage = () => {
    const [searchParams] = useSearchParams();
    const sessionId = searchParams.get('session_id');
    const [status, setStatus] = useState('loading'); // loading, paid, cancelled
    const [progress, setProgress] = useState(0);
    useEffect(() => {
        if (!sessionId) return;

         // Fake progress animation for a smoother feel
        const progressInterval = setInterval(() => {
            setProgress(prev => (prev < 90 ? prev + 10 : prev));
        }, 300);

        const checkStatus = async () => {
            try {
                const res = await fetch(`/api/checkout-status?session_id=${sessionId}`);
                const data = await res.json();

                if (data.status === 'paid') {
                      setProgress(100);
                    setStatus('paid');
                    clearInterval(pollInterval);
                    clearInterval(progressInterval);
                } else if (data.status === 'cancelled') {
                    setStatus('cancelled');
                    clearInterval(pollInterval);
                     clearInterval(progressInterval);
                }
            } catch (err) {
                console.error("Verification error:", err);
            }
        };

        // Poll every 2 seconds because webhooks can take a moment to fire
        const pollInterval = setInterval(checkStatus, 2000);
        checkStatus(); // Initial check

        return () => {
            clearInterval(pollInterval);
            clearInterval(progressInterval);
            }
    }, [sessionId]);

    return (
        <div className="flex flex-col items-center justify-center min-h-screen bg-slate-50 p-4">
            <div className="bg-white p-10 rounded-2xl shadow-2xl text-center max-w-md w-full transition-all">
                {status === 'loading' ? (
                    <>
                        <h2 className="text-xl font-bold text-slate-800 mb-4">Verifying Booking...</h2>
                        {/* Custom Progress Bar Container */}
                        <div className="w-full bg-gray-200 rounded-full h-3 mb-4 overflow-hidden">
                            {/* Animated Filler */}
                            <div 
                                className="bg-blue-600 h-full transition-all duration-500 ease-out" 
                                style={{ width: `${progress}%` }}
                            ></div>
                        </div>
                        <p className="text-sm text-gray-500 italic">Connecting to secure payment gateway...</p>
                    </>
                ) : status === 'paid' ? (
                    <>
                        <HiCheckCircle className="text-green-500 text-8xl mx-auto mb-4 drop-shadow-sm" />
                        <h1 className="text-3xl font-extrabold text-slate-900 mb-2">Success!</h1>
                        <p className="text-gray-600 mb-8">Your tutoring session is confirmed. Check your inbox for the calendar invite.</p>
                        <Link to="/" className="w-full block bg-slate-900 text-white py-3 rounded-xl font-bold hover:bg-slate-800 transition-colors">
                            View More Tutors
                        </Link>
                    </>
                ) : (
                    <>
                        <HiXCircle className="text-red-500 text-8xl mx-auto mb-4" />
                        <h1 className="text-3xl font-extrabold text-slate-900 mb-2">Failed</h1>
                        <p className="text-gray-600 mb-8">We couldn't confirm your payment. Please try again or contact support.</p>
                        <Link to="/" className="w-full block bg-red-600 text-white py-3 rounded-xl font-bold hover:bg-red-700 transition-colors">
                            Return to Schedule
                        </Link>
                    </>
                )}
            </div>
        </div>
    );
};
export default SuccessPage;